import React, { useState } from 'react';
import classes from './style.module.scss';
import Icon from '~/app/common/Icon';
import { TrainingDetail } from '~/training/types';

export interface InstructorInfoProps {
  instructor: TrainingDetail['instructor'];
}

export type InstructorInfoComponent = React.FC<InstructorInfoProps>;

const InstructorInfo: InstructorInfoComponent = ({ instructor }) => {
  const [imgError, setImgError] = useState(false);

  return (
    <div className={classes['instructor-info']}>
      {instructor?.avatar && !imgError ? (
        <img
          className={classes['instructor-avatar']}
          src={instructor.avatar}
          alt={instructor.name ?? ''}
          onError={() => setImgError(true)}
        />
      ) : (
        <div className={classes['instructor-avatar-fallback']}>
          <Icon name="person" size={24} />
        </div>
      )}
      <div>
        <div className={classes['instructor-name']}>{instructor?.name}</div>
        <div className={classes['instructor-email']}>{instructor?.email}</div>
      </div>
    </div>
  );
};

export default InstructorInfo;
